<template>
  <div class="video">
    <video ref="video" id="video" :src="url" autoplay controls @ended="onEnd"></video>
    <div class="overlay" v-if="showOverlay">
      <button class="back" @click="back">&#60;</button>
      <h1>{{title}}</h1>
      <button class="back" @click="next">&#62;</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Video',
  props: {
    url: String,
    title: String
  },
  data() {
    return {
      showOverlay: true,
      timeout: setTimeout(() => {
        this.showOverlay = false;
      }, 2000)
    }
  },
  methods: {
    onEnd() {
      this.$emit('onEnd')
    },
    back() {
      this.$emit('onBack')
    },
    next() {
      this.$emit('next');
    },
    getExtension(url) {
      const partials = url.split('.');

      return partials[partials.length - 1]
    },
    onMouseMove() {
      this.showOverlay = true;

      clearTimeout(this.timeout)

      this.timeout = setTimeout(() => {
        this.showOverlay = false;
      }, 2000);
    }
  },
  mounted() {
    document.getElementById('video').addEventListener('mousemove', this.onMouseMove)
    document.getElementById('video').addEventListener('click', this.onMouseMove)
  }
}
</script>

<style scoped>

.video {
  height: 100vh;
  overflow: hidden;

  position: relative;

  background-color: black;
}

.overlay {
  position: absolute;
  top: 0;

  z-index: 10;

  display: flex;

  justify-content: space-between;
}

video {
  height: 100vh;
  width: 100%;
}

.back {
  background-color: rgb(59, 59, 59);
  color: white;
  font-size: 30px;

  width: 60px;
  height: 60px;

  border-radius: 50%;

  margin: 10px 0 0 10px;

  animation: fadein .5s 1;
}

@keyframes fadein {
  0%{
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

h1 {
  padding: 5px 20px 0 20px;
}

</style>



// WEBPACK FOOTER //
// src/components/Video.vue